'use strict'

module.exports = class OffersMapCategoryFilters

  onChangeCallbacks: []

  rootUrl: '/merchant-page/offers-map'

  templates:
    main: require '../main.html.mustache'

  constructor: ({ el }) ->
    @$el = $ el

    @fetchCategories (err, categories) =>
      return if err?
      @categories = categories
      @render()
      @$categories = @$el.find '.categories'
      @bindings()

  render: ->
    data = { categories: @categories }
    data.translate = data.t = -> (str) -> I18n.t str
    @$el.html @templates.main.render data

  bindings: ->
    @$categories.find('.category').click (evt) =>
      oldValue = @value()
      $category = $ evt.currentTarget

      if $category.hasClass 'active'
        # If the user clicks on the category that was already selected, we remove the selection.
        $category.removeClass 'active'
      else
        @$categories.find('.category.active').removeClass 'active'
        $category.addClass 'active'

      @triggerChange() unless oldValue is @value()

  fetchCategories: (cb) ->
    $.ajax
      url: "#{@rootUrl}/categories"
      type: 'GET'
      contentType: 'application/json'
      dataType: 'json'
      success: (res) =>
        return cb(new Error(res?.error?.code)) unless res?.result is 'ok'
        return cb null, res.data.categories
      error: ->
        return cb(new Error('Request Failed'))

  triggerChange: =>
    cb() for cb in @onChangeCallbacks

  onChange: (cb) ->
    @onChangeCallbacks.push cb

  value: ->
    @$categories.find('.category.active').data 'id'

  clear: ->
    $active = @$categories.find '.category.active'
    shouldTriggerChange = $active.length > 0
    $active.removeClass 'active'
    @triggerChange() if shouldTriggerChange
